<template>
  <div>
    <popupBox v-if="showPopup"></popupBox>
    <router-view></router-view>
  </div>
</template>

<script>
import PopupBox from "@/components/PopupBox.vue";
export default {
  name: "App",
  components: {
    PopupBox,
  },
  computed: {
    showPopup() {
      return this.$store.getters.getShowPopup
    }
  }
};
</script>

<style lang="scss">
:root {
  --app-height: 100%;
  margin: 0 auto;
}
#app {
  font-family: DIN Condensed Bold, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  text-align: center;
  color: var(--white);
}
body {
  height: var(--app-height);
  width: 100vw;
  background-size: 100%;
  margin: 0;
  align-content: center;
  --white: #FFFFFF;
  --orange: #FFCC88;
  --light-blue: #BFEAFF;
  --blue: #66AADD;
  --dark-blue: #4477AA;
  --indigo: #002266;
  --black: #000000;
  --transparent-black: #00000088;
  background-color: var(--dark-blue);
}

@font-face {
  font-family: "Kefa";
  src: url(assets/fonts/kefa-bold.ttf) format("truetype");
}
h1 {
  font-family: "Kefa", sans-serif;
  font-size: 2em;
  line-height: 1em;
  letter-spacing: 0em;
  font-weight: inherit;
}
h2 {
  font-family: "Kefa", sans-serif;
  font-size: 1.25em;
  line-height: 1.125em;
  letter-spacing: 0em;
  font-weight: inherit;
}
p {
  font-family: "Kefa", sans-serif;
  font-size: 1em;
  letter-spacing: 0em;
  font-weight: inherit;
}
.drop-shadow {
  filter: drop-shadow(0 0 0.1em var(--indigo))
          drop-shadow(0 0 0.1em var(--indigo))
          drop-shadow(0 0 0.1em var(--indigo));
}

.anchor { background-image: url("./assets/stills/anchor.jpg"); }
.astrolabe { background-image: url("./assets/stills/astrolabe.jpg"); }
.ballast-bricks { background-image: url("./assets/stills/ballast_bricks.jpg"); }
.beardman-jugs { background-image: url("./assets/stills/beardman_jugs.jpg"); }
.bilge-pumps { background-image: url("./assets/stills/bilge_pumps.jpg"); }
.captains-bed { background-image: url("./assets/stills/captains_bed.jpg"); }
.cargo-barrels { background-image: url("./assets/stills/cargo_barrels.jpg"); }
.cargo-hatch { background-image: url("./assets/stills/cargo_hatch.jpg"); }
.ceremonial-spear { background-image: url("./assets/stills/ceremonial_spear.jpg"); }
.cleats { background-image: url("./assets/stills/cleats.jpg"); }
.constable { background-image: url("./assets/stills/constable.jpg"); }
.cooking { background-image: url("./assets/stills/cooking.jpg"); }
.cow-horn { background-image: url("./assets/stills/cow_horn.jpg"); }
.falcon-gun { background-image: url("./assets/stills/falcon_gun.jpg"); }
.gun-ports { background-image: url("./assets/stills/gun_ports.jpg"); }
.harquebus { background-image: url("./assets/stills/harquebus.jpg"); }
.lanterns { background-image: url("./assets/stills/lanterns.jpg"); }
.leadline { background-image: url("./assets/stills/leadline.jpg"); }
.main-deck { background-image: url("./assets/stills/main_deck.jpg"); }
.mast { background-image: url("./assets/stills/mast.jpg"); }
.medical-kit { background-image: url("./assets/stills/medical_kit.jpg"); }
.medical-tools { background-image: url("./assets/stills/medical_tools.jpg"); }
.message-sticks { background-image: url("./assets/stills/message_sticks.jpg"); }
.merchants-bed { background-image: url("./assets/stills/merchants_bed.jpg"); }
.ramrods { background-image: url("./assets/stills/ramrods.jpg"); }
.rationed-food { background-image: url("./assets/stills/rationed_food.jpg"); }
.ratlines { background-image: url("./assets/stills/ratlines.jpg"); }
.replica-chart { background-image: url("./assets/stills/replica_chart.jpg"); }
.sails { background-image: url("./assets/stills/sails.jpg"); }
.shots { background-image: url("./assets/stills/shots.jpg"); }
.sleeping-quarters { background-image: url("./assets/stills/sleeping_quarters.jpg"); }
.spare-rigging { background-image: url("./assets/stills/spare_rigging.jpg"); }
.spare-sails { background-image: url("./assets/stills/spare_sails.jpg"); }
.spices { background-image: url("./assets/stills/spices.jpg"); }
.sword { background-image: url("./assets/stills/sword.jpg"); }
.tiller { background-image: url("./assets/stills/tiller.jpg"); }
.tiller-stoppers { background-image: url("./assets/stills/tiller_stoppers.jpg"); }
.traverse-board { background-image: url("./assets/stills/traverse_board.jpg"); }
.water-barrels { background-image: url("./assets/stills/water_barrels.jpg"); }
.whipstaff { background-image: url("./assets/stills/whipstaff.jpg"); }
.windlass { background-image: url("./assets/stills/windlass.jpg"); }
.wooden-box { background-image: url("./assets/stills/wooden_box.jpg"); }
</style>